import { render, staticRenderFns } from "./cityShansong.vue?vue&type=template&id=3d523edf&scoped=true"
import script from "./cityShansong.vue?vue&type=script&lang=js"
export * from "./cityShansong.vue?vue&type=script&lang=js"
import style0 from "./cityShansong.vue?vue&type=style&index=0&id=3d523edf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d523edf",
  null
  
)

export default component.exports